import { Navigate, Outlet, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";

export default function ClientGuard() {
  const { user, isClient, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main style={{ padding: "6rem var(--page-px)" }}>
        <p className="mono-tag">// cargando sesión…</p>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // los admin también pueden ver el portal (para revisión)
  if (!isClient && !isAdmin) {
    return (
      <main style={{ padding: "6rem var(--page-px)", maxWidth: 640, margin: "0 auto" }}>
        <p className="mono-tag">// acceso restringido</p>
        <h1 style={{ fontSize: "var(--step-3)", fontWeight: 300, marginTop: "0.5rem" }}>
          Tu cuenta aún no tiene acceso al portal de clientes.
        </h1>
        <p style={{ color: "var(--color-ink-soft)", marginTop: "1rem" }}>
          El acceso se habilita desde Aya Technologies. Si tienes un proyecto con
          nosotros, escríbenos a{" "}
          <a
            href="mailto:ventas@ayatech.com.pe"
            style={{ color: "var(--color-accent)", borderBottom: "1px solid currentColor" }}
          >
            ventas@ayatech.com.pe
          </a>{" "}
          para activarlo.
        </p>
        <p style={{ marginTop: "1.5rem" }}>
          <Link to="/" style={{ color: "var(--color-ink)", borderBottom: "1px solid var(--color-line)" }}>
            ← Volver al inicio
          </Link>
        </p>
      </main>
    );
  }

  return <Outlet />;
}
